<template>
  <div>
    <CModal v-show="showStDetails" @close="closeStModal" modalIsLarge footer>
      <template v-slot:title>
        <h3 class="  text-center text-black-50 fw-bold">
          Statement Details
        </h3>
      </template>
      <template v-slot:body>
        <div v-if="singleStatement !== null">
          <div class=" mt-1">
            <p class="m-0 text-dark">
              Date:
              <span class="fw-bold"> {{ singleStatement.transaction_date }}</span>
            </p>
          </div>
          <div class="mt-1">
            <p class=" m-0 text-dark">
              Credit Amount:
              <span class="fw-bold">
                &#8358;{{ singleStatement.credit }}</span
              >
            </p>
          </div>
          <div class="mt-1">
            <p class=" m-0 text-dark">
              Debit Amount:
              <span class="fw-bold">
                &#8358;{{ singleStatement.debit }}</span
              >
            </p>
          </div>
          <div class="mt-1">
            <p class=" m-0 text-dark">
              Openinng Balance:
              <span class="fw-bold">
                &#8358;{{ singleStatement.opening_balance }}</span
              >
            </p>
          </div>
          <div class="mt-1">
            <p class=" m-0 text-dark">
              Closing Balance:
              <span class="fw-bold">
                &#8358;{{ singleStatement.balance }}</span
              >
            </p>
          </div>
          <div class="mt-1">
            <p class=" m-0 text-dark">
              Transaction Amount:
              <span class="fw-bold">
                &#8358;{{ singleStatement.amount }}</span
              >
            </p>
          </div>
          <div class="row mt-1">
            <div class="col-md-6">
              <div class=" form-group">
                <label for="">Narration</label>
                <textarea
                  style="resize: none"
                  name=""
                  id=""
                  cols="30"
                  rows="3"
                  class=" form-control"
                  v-model="singleStatement.narration"
                ></textarea>
              </div>
            </div>            
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeStModal"
        >
          Close
        </button>
      </template>
    </CModal>
    <!-- <div v-if="statement !== null" class=" mt-2">
      <div class="mt-1">
        <p class=" m-0 text-dark">
          Balanace AT Start:
          <span class="fw-bold">
            &#8358;{{ statement.balance_at_start.toLocaleString() }}</span
          >
        </p>
      </div>
      <div class=" mt-1">
        <p class=" m-0 text-dark">
          Balanace AT End:
          <span class="fw-bold">
            &#8358;{{ statement.balance_at_end.toLocaleString() }}</span
          >
        </p>
      </div>
      <div class="mt-1">
        <p class="m-0 text-dark">
          Total Credit:
          <span class=" fw-bold">
            &#8358;{{ statement.total_credit.toLocaleString() }}</span
          >
        </p>
      </div>
      <div class=" mt-1">
        <p class="m-0 text-dark">
          Total Debit:
          <span class="fw-bold">
            &#8358;{{ statement.total_debit.toLocaleString() }}</span
          >
        </p>
      </div>
    </div> -->

    <div v-if="statement !== null">
      <CDataTable
        :items="statement"
        :fields="sFields"
        :items-per-page="50"
        pagination
        sorter
        tableFilter
      >
        <!-- <template #updated_at="{item}">
          <td class="table--action-mobile">
            {{ item.updated_at | date }}
          </td>
        </template> -->
        <template #action="{item}">
          <td
            class="table--action-mobile"
            v-if="permissions.includes('view-payment')"
          >
            <button class="button btn-primary" @click="openStModal(item)">
              View
            </button>
          </td>
        </template>
      </CDataTable>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import CModal from "@/components/CModal.vue";
const sFields = [
  "transaction_date",
  "instrument_number",
  "reference_id",
  "narration",
  "amount",
  "credit",
  "debit",
  "opening_balance",
  "balance",
  "reversal_status",
  "is_card",
  "action"
];

export default {
  name: "BankStatement",
  props: {
    statement: {
      type: [Object],
      default: null
    }
  },
  components: {
    CDataTable,
    CModal
    // CCard
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  data() {
    return {
      sFields,
      singleStatement: null,
      showStDetails: false
    };
  },
  methods: {
    closeStModal() {
      this.showStDetails = false;
      this.singleStatement = null;
    },
    openStModal(item) {
      // console.log(item);
      this.singleStatement = item;
      this.showStDetails = true;
    }
  }
};
</script>

<style scoped>
.table td, .table th{
  padding: 0 !important;
}

.table{
  font-size: 11px !important;
}
</style>
